import React from "react";
import "../styles/Services.css";

function Services() {
  return (
    <div className="services-page">

      {/* =========================
      FACEBOOK ADS SECTION
      ========================= */}

      <section className="service-section">
        <h2 className="service-heading">
          Facebook Ads Marketing
        </h2>
        <p className="service-subheading">
          Grow your business with high-converting Facebook & Instagram ad campaigns.
          We create powerful ad strategies, target the right audience, and maximize your ROI.
        </p>

        <div className="pricing-container">
          <div className="pricing-card">
            <h3>Basic</h3>
            <h4>₹7,999</h4>
            <ul>
              <li>Ad Setup</li>
              <li>Audience Targeting</li>
              <li>1 Campaign</li>
              <li>Basic Optimization</li>
            </ul>
            <button>Get Started</button>
          </div>
          <div className="pricing-card popular">
            <h3>Standard</h3>
            <h4>₹9,999</h4>
            <ul>
              <li>Everything in Basic</li>
              <li>2 Campaigns</li>
              <li>Advanced Targeting</li>
              <li>Weekly Reports</li>
            </ul>
            <button>Most Popular</button>
          </div>
          <div className="pricing-card">
            <h3>Premium</h3>
            <h4>₹19,999</h4>
            <ul>
              <li>All Standard Features</li>
              <li>Unlimited Campaigns</li>
              <li>Daily Optimization</li>
              <li>High ROI Strategy</li>
            </ul>
            <button>Go Premium</button>
          </div>
        </div>
      </section>

      {/* =========================
      SOCIAL MEDIA MARKETING SECTION
      ========================= */}

      <section className="new-service-section">
        <h2 className="smm-heading">Social Media Marketing</h2>
        <p className="smm-subheading">
          Boost your brand presence across social platforms. We create engaging campaigns to grow followers, drive traffic, and increase conversions.
        </p>

        {/* ROW 1 - Image Left */}
        <div className="service-row">
          <div className="service-img">
            <img src="/image-video.jpg" alt="Social Media Marketing" />
          </div>
          <div className="service-content">
            <h3>Instagram & Facebook Campaigns</h3>
            <p>
              Crafting scroll-stopping ads, stories, and posts to increase engagement and attract your ideal audience.
            </p>
          </div>
        </div>

        {/* ROW 2 - Image Right, Content Left */}
        <div className="service-row reverse">
          <div className="service-content">
            <h3>Targeted Paid Ads</h3>
            <p>
              Optimize ad spend with precise audience targeting, A/B testing, and continuous monitoring for maximum ROI.
            </p>
          </div>
          <div className="service-img">
            <img src="/image-video-2.jpg" alt="Paid Ads" />
          </div>
        </div>

        {/* ROW 3 - Image Left */}
        <div className="service-row">
          <div className="service-img">
            <img src="/ceation-image.webp" alt="Content Creation" />
          </div>
          <div className="service-content">
            <h3>Content Creation & Strategy</h3>
            <p>
              We design engaging visuals, posts, and video content aligned with your brand voice for better conversions.
            </p>
          </div>
        </div>




      </section>


<section className="ecommerce-section">
  <h2 className="ecom-heading">E-Commerce Services</h2>
  <p className="ecom-subheading">Grow your online store with tailored strategies, targeted marketing, and stunning content to boost sales.</p>

  {/* Box 1 */}
  <div className="ecom-row">
    <div className="ecom-img">
      <img src="box-1.jpg" alt="E-Commerce Visibility" />
    </div>
    <div className="ecom-content">
      <h3>Increase Social Media Visibility</h3>
      <p>We optimize your social media presence to attract more customers and grow your e-commerce store audience efficiently.</p>
      <button>Read More</button>
    </div>
  </div>

  {/* Box 2 */}
  <div className="ecom-row reverse">
    <div className="ecom-img">
      <img src="box-2.webp" alt="Customized Social Media Posts" />
    </div>
    <div className="ecom-content">
      <h3>Customized Social Media Posts</h3>
      <p>Create engaging posts and ads specifically designed to increase your e-commerce sales and attract new customers.</p>
      <button>Read More</button>
    </div>
  </div>

  {/* Box 3 */}
  <div className="ecom-row">
    <div className="ecom-img">
      <img src="box-3.jpg" alt="Strategic Marketing" />
    </div>
    <div className="ecom-content">
      <h3>Strategic E-Commerce Marketing</h3>
      <p>Our team targets the right platforms, retargets visitors, and enhances your online presence for maximum conversions.</p>
      <button>Read More</button>
    </div>
  </div>
</section>




<section className="graphic-design-section">
  <h2 className="gd-heading">Graphic Design Services</h2>
  <p className="gd-subheading">We craft visually stunning graphics and designs to elevate your brand’s online presence and attract your target audience.</p>

  <div className="gd-row">
    {/* CONTENT LEFT */}
    <div className="gd-content">
      <h3>Professional Graphic Design</h3>
      <p>From banners to social media visuals, our team creates impactful designs that communicate your brand message effectively.</p>
      <button onClick={() => window.location.href='/contact'}>Contact Us</button>
    </div>

    {/* IMAGE RIGHT */}
    <div className="gd-img">
      <img src="gp-1.jpg" alt="Graphic Design Services" />
    </div>
  </div>
</section>

    </div>
  );
}

export default Services;